import React from 'react';

function SyncSuccess({ color = '#808080', color2 = '#00821F', ...props }) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" {...props}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M4.95 19.05C3.1375 17.25 2 14.7625 2 12C2 7.33751 5.1875 3.43751 9.5 2.32501V4.93751C6.5875 5.96251 4.5 8.73751 4.5 12C4.5 14.075 5.35 15.9375 6.7 17.3L9.5 14.5V22H2L4.95 19.05ZM14.5 2H22L19.05 4.95C20.8625 6.75 22 9.2375 22 12C22 12.4939 21.9642 12.9792 21.8952 13.4535C21.2056 12.8928 20.3891 12.4821 19.4952 12.2713C19.4984 12.1813 19.5 12.0908 19.5 12C19.5 9.925 18.65 8.0625 17.3 6.7L14.5 9.5V2Z"
                fill={color}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M18 13C15.24 13 13 15.24 13 18C13 20.76 15.24 23 18 23C20.76 23 23 20.76 23 18C23 15.24 20.76 13 18 13ZM17 20.5L14.5 18L15.205 17.295L17 19.085L20.795 15.29L21.5 16L17 20.5Z"
                fill={color2}
            />
        </svg>
    );
}

export default React.memo(SyncSuccess);
